import NotificationTypes from './notifications.types';

export const getNotifications = () => ({
    type: NotificationTypes.FETCH_NOTIFICATIONS.PENDING,
});
